import ResourcesDispatcher from "../../config/ResourcesDispatcher";
import Utils from "../../utils/Utils";
export default class LinkReel {
    constructor(x, y, index, orientation, linkCellCreation) {
        this.index = 0;
        this.spinProgressValue = { value: 0 };
        this.spinAnimationDuration = 300;
        this.suspenseDuration = 600;
        this.virtualReelPosition = 0;
        this.realMemoIndex = 0;
        /** Cells of the reel */
        this.linkCells = [];
        this.isFixedCell = false;
        this.t0 = 0;
        this.preStopMs = 2200; // tempo “attivo” prima del bounce (fisso!)
        this.spinMainButtonTween = null;
        this.isButtonSpinning = false;
        this.baseSpeed = 1.9; // velocità base
        this.speedJitter = 0.08; // piccola variazione
        this.delayPerReel = 120; // ms di ritardo per indice
        this.extraDelayJitter = 50; // jitter per non farli allineare
        this.index = index;
        this.cellSize = ResourcesDispatcher.GAME_CONSTANTS.CELL_SIZE_LINKSPIN;
        this.numOfLinkCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_CELLS_PER_REEL;
        this.numOfExtraLinkCellsPerReel = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_EXTRA_LINK_CELLS_PER_REEL;
        this.linkCellsPosition = linkCellCreation.cellPositions;
        this.lastLinkCellIndex = ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_CELLS_PER_REEL + this.numOfExtraLinkCellsPerReel - 1;
        // this.linkSuspenseRaw = ResourcesDispatcher.SPINES.Reel_Suspense_Link;
        // this.linkSuspense = scene.add.spine(this.linkCellsPosition[1].x, this.linkCellsPosition[1].y, this.linkSuspenseRaw.jsonKey, this.linkSuspenseRaw.atlasKey).setOrigin(0.5).setVisible(false);
        // this.linkSuspenseReelRaw = ResourcesDispatcher.SPINES.Reel_Suspense_Link_Rullo;
        // this.linkSuspenseReel = scene.add.spine(this.linkCellsPosition[1].x, this.linkCellsPosition[1].y, this.linkSuspenseReelRaw.jsonKey, this.linkSuspenseReelRaw.atlasKey).setOrigin(0.5).setVisible(false);
        this.container = layoutBuilder.findByPath(`LinkSpin/grid/reels/reel_${index}`);
        if (this.container.getByName(`contorno_link`)) {
            this.contornoLink = this.container.getByName(`contorno_link`);
            this.contornoLink.setTexture(ResourcesDispatcher.ATLAS.LINKCELL_FRAME.key, ResourcesDispatcher.ATLAS.LINKCELL_FRAME.frame);
        }
        this.startDelayMs = index * this.delayPerReel + Phaser.Math.Between(0, this.extraDelayJitter);
        this.spinSpeed = this.baseSpeed + index * 0.12 + Phaser.Math.FloatBetween(-this.speedJitter, this.speedJitter);
        this.phaseOffsetPx = Math.round((index * (this.cellSize.height / ResourcesDispatcher.GAME_CONSTANTS.NUM_OF_LINK_REELS)) % this.cellSize.height);
    }
    /** PUBLIC GETTERS **/
    getIndex() {
        return this.index;
    }
    getCells() {
        return this.linkCells;
    }
    getContainer() {
        return this.container;
    }
    getIsFixedCell() {
        return this.isFixedCell;
    }
    /*******************/
    /** PUBLIC SETTERS **/
    setIndex(value) {
        this.index = value;
    }
    setIsFixedCell(value) {
        this.isFixedCell = value;
    }
    /*******************/
    resetFlagsAndCounters() {
        this.virtualReelPosition = Utils.getRandomInt(0, scene.linkSpinGameArea.virtualGrid[this.index].length - 1);
        this.spinProgressValue = { value: 0 };
        this.canStop = false;
        this.stopped = false;
        this.realMemoIndex = 0;
        this.removeStopEvent();
    }
    removeStopEvent() {
        if (this.stopEvent) {
            this.stopEvent.remove(false);
        }
        this.stopEvent = undefined;
    }
    resetCellsPositions() {
        this.linkCells.forEach((linkCell, index) => {
            linkCell.getContainer().y = this.linkCellsPosition[index].y;
        });
    }
    reIndexCells() {
        let linkCells = [];
        for (let i = 1; i < this.numOfLinkCellsPerReel + this.numOfExtraLinkCellsPerReel; i++) {
            linkCells[i - 1] = this.linkCells[i];
            this.linkCells[i].setIndex(i - 1);
        }
        this.linkCells[0].setIndex(this.lastLinkCellIndex);
        linkCells[this.lastLinkCellIndex] = this.linkCells[0];
        this.linkCells = [];
        this.linkCells = linkCells;
    }
    get stepMs() { return this.spinAnimationDuration / this.spinSpeed; }
    configureSpinTween() {
        this.resetFlagsAndCounters();
    }
    //Chiamato dal gioco per far partire il giro del rullo
    spin(mainButtonBackground) {
        if (this.isFixedCell) {
            scene.linkSpinGameArea.notifySpinCompleted(this.index);
            return;
        }
        this.spinProgress.play();
        if (mainButtonBackground) {
            if (window.isButtonSpinning === false) {
                window.isButtonSpinning = true;
                this.spinMainButtonTween = Utils.spinMainButtonRotation(mainButtonBackground);
            }
        }
    }
    // This check is done for safety. It should NEVER happen that the reels are still spinning when this method is called.
    securityCheckStop() {
        if (this.spinProgress?.isPlaying()) {
            this.spinProgress.stop();
            this.resetCellsPositions();
        }
        else if (this.bounceTween1?.isPlaying()) {
            this.bounceTween1.stop();
            this.resetCellsPositions();
        }
        else if (this.bounceTween2?.isPlaying()) {
            this.bounceTween2.stop();
            this.resetCellsPositions();
        }
    }
    reset() {
        this.container.setVisible(true);
    }
    refreshCellPositions() {
        const numOfCells = this.numOfLinkCellsPerReel + this.numOfExtraLinkCellsPerReel;
        for (let i = 0; i < numOfCells; i++) {
            const node = layoutBuilder.getNodeByPath(`LinkSpin/grid/reels/reel_${this.index}/cell_${i}`);
            if (node) {
                this.linkCellsPosition[i] = {
                    x: node.coordinates.relative_top_left_to_parent?.x || 0,
                    y: node.coordinates.relative_top_left_to_parent?.y || 0
                };
            }
        }
        this.linkCells.forEach(linkCell => {
            const pos = this.linkCellsPosition[linkCell.getIndex()];
            if (pos) {
                linkCell.getContainer().setPosition(pos.x, pos.y);
                linkCell.refreshInternalPositions();
            }
        });
    }
    //     public lockIfNeeded(animate: boolean = false): Promise<void> {
    //     return new Promise(async (resolve) => {
    //         if (this.linkCellType !== LinkCellType.FIXED) {
    //             resolve();
    //             return;
    //         }
    //         if (this.cellLocked) {
    //             resolve();
    //             return;
    //         }
    //         if (this.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_LINK || this.getMemo() === ResourcesDispatcher.GAME_CONSTANTS.S_COLLECT_COLLECTED) {
    //             this.cellLocked = false;
    //             resolve();
    //             return;
    //         }
    //         let extraSymbolsInfo = null;
    //         switch (this.getMemo()) {
    //             case ResourcesDispatcher.GAME_CONSTANTS.S_MINI:
    //                 extraSymbolsInfo = this.scene.gameArea.gameDataManager.getReelSpecialInfo()
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.miniLink > -1)
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.reelIndex === Math.floor(this.linkReel.getIndex() / 5))
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.miniLink === this.linkReel.getIndex() % 5)[0];
    //                 break;
    //             case ResourcesDispatcher.GAME_CONSTANTS.S_MAJOR:
    //                 extraSymbolsInfo = this.scene.gameArea.gameDataManager.getReelSpecialInfo()
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.majorLink > -1)
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.reelIndex === Math.floor(this.linkReel.getIndex() / 5))
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.majorLink === this.linkReel.getIndex() % 5)[0];
    //                 break;
    //             case ResourcesDispatcher.GAME_CONSTANTS.S_GRAND:
    //                 extraSymbolsInfo = this.scene.gameArea.gameDataManager.getReelSpecialInfo()
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.grandLink > -1)
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.reelIndex === Math.floor(this.linkReel.getIndex() / 5))
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.grandLink === this.linkReel.getIndex() % 5)[0];
    //                 break;
    //             case ResourcesDispatcher.GAME_CONSTANTS.S_MINOR:
    //                 extraSymbolsInfo = this.scene.gameArea.gameDataManager.getReelSpecialInfo()
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.minorLink > -1)
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.reelIndex === Math.floor(this.linkReel.getIndex() / 5))
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.minorLink === this.linkReel.getIndex() % 5)[0];
    //                 break;
    //             case ResourcesDispatcher.GAME_CONSTANTS.S_LINK_MULTIPLIER_X2:
    //                 extraSymbolsInfo = this.scene.gameArea.gameDataManager.getReelSpecialInfo()
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.x2 > -1)
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.reelIndex === Math.floor(this.linkReel.getIndex() / 5))
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.x2 === this.linkReel.getIndex() % 5)[0];
    //                 break;
    //             case ResourcesDispatcher.GAME_CONSTANTS.S_LINK_MULTIPLIER_X3:
    //                 extraSymbolsInfo = this.scene.gameArea.gameDataManager.getReelSpecialInfo()
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.x3 > -1)
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.reelIndex === Math.floor(this.linkReel.getIndex() / 5))
    //                     ?.filter((extraSymbolInfo: any) => extraSymbolInfo.x3 === this.linkReel.getIndex() % 5)[0];
    //                 break;
    //         }
    //         if (!extraSymbolsInfo) {
    //             this.cellLocked = false;
    //             resolve();
    //             return;
    //         }
    //         if (!extraSymbolsInfo.activeStatus) {
    //             this.cellLocked = true;
    //             resolve();
    //         } else {
    //             this.cellLocked = false;
    //             resolve();
    //         }
    //     });
    // }
    lockIfNeeded(animate = false) {
        return new Promise((resolve) => {
            // Nel codice attuale il lock del reel coincide con lo stato "fixed".
            if (!this.isFixedCell) {
                this.setIsFixedCell(true);
            }
            resolve();
        });
    }
    unlockIfNeeded(animate = false) {
        return new Promise((resolve) => {
            // Se il reel e' fixed e arriva un unlock, va sbloccato.
            if (this.isFixedCell) {
                this.setIsFixedCell(false);
            }
            resolve();
        });
    }
}
